module.exports = __webpack_public_path__ + "50fc68cefa16d86af729b8c5b4bc56a9.png";